var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-display"},_vm._l((_vm.categories),function(entries,index){return _c('GridDisplay',{key:index,attrs:{"title":index,"entries":entries,"search-text":_vm.searchText}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }